import { createFileRoute } from "@tanstack/react-router"
import ClosedPurchaseOrdersTab from "~/components/purchaseOrder/tabs/ClosedPurchaseOrdersTab"
import { WorkspacePage } from "~/components/design-system/pages"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/_layout/closed")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Purchase Orders - Closed")
  return (
    <WorkspacePage fillContent contentClassName="p-0">
      <ClosedPurchaseOrdersTab />
    </WorkspacePage>
  )
}
